const POSTGRES_IDENTIFIER_REGEX = /^[A-Za-z_][A-Za-z0-9_$]*$/;
const POSTGRES_IDENTIFIER_INVALID_CHARS = /[^A-Za-z0-9_$]+/g;
const POSTGRES_IDENTIFIER_INVALID_START = /^[^A-Za-z_]+/;

export function isValidPostgresIdentifier(value) {
  return typeof value === 'string' && POSTGRES_IDENTIFIER_REGEX.test(value);
}

export function sanitizePostgresIdentifierSuggestion(name) {
  const original = typeof name === 'string' ? name.trim() : '';

  if (!original) {
    return {
      value: 'importacao_csv',
      adjusted: true
    };
  }

  if (isValidPostgresIdentifier(original)) {
    return {
      value: original,
      adjusted: false
    };
  }

  const startsWithInvalidCharacter = !/^[A-Za-z_]/.test(original);

  if (startsWithInvalidCharacter) {
    const remainder = original.replace(POSTGRES_IDENTIFIER_INVALID_START, '');
    const sanitizedRemainder = remainder
      .replace(POSTGRES_IDENTIFIER_INVALID_CHARS, '_')
      .replace(/_+/g, '_')
      .replace(/^_+|_+$/g, '');

    return {
      value: sanitizedRemainder ? `importacao_csv_${sanitizedRemainder}` : 'importacao_csv',
      adjusted: true
    };
  }

  const sanitizedValue = original
    .replace(POSTGRES_IDENTIFIER_INVALID_CHARS, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');

  if (isValidPostgresIdentifier(sanitizedValue)) {
    return {
      value: sanitizedValue,
      adjusted: true
    };
  }

  return {
    value: 'importacao_csv',
    adjusted: true
  };
}
